import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginTop: 17,
  },
  listStyle: {
    flexGrow: 0,
    marginTop: 12,
    marginBottom: 19.4,
    paddingLeft: 12,
  },
  description: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 14.6,
    lineHeight: 18.7,
    paddingHorizontal: 16,
  },
  contentContainerStyle: {
    paddingRight: 28,
  },
});
